// extracted by mini-css-extract-plugin
export default {"root":"Warning_root__jaeLj","icon":"Warning_icon__LWB7i","message":"Warning_message__YakGa"};